import CardStockDetailNew from "../../../components/screen/inventory/CardStock/CardStockDetailNew";
import HOC from "../../../components/HOC";
import PageTemplateNew from "../../../components/common/particles.jsx/PageTemplateNew";
import BreadcrumbCardstock from "../../../components/screen/inventory/CardStock/BreadcrumbCardstock";
import { useQuery } from "@tanstack/react-query";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { getDetailCardStockNew } from "../../../services/InventoryAPI";
import { useEffect } from "react";
import CardStockDetailBatch from "../../../components/screen/inventory/CardStock/CardStockDetailBatch";

const CardStockDetailBatchPage = ({ isWarehouse }) => {
  const { productId = "" } = useParams();
  const { batchId } = useParams();
  const companyId = localStorage.getItem("company_id");

  const { data: dataDetail, isFetching: isFetchingDetail } = useQuery({
    queryKey: ["detail-batch"],
    queryFn: () =>
      getDetailCardStockNew(
        productId,
        companyId,
        batchId,
        isWarehouse ? isWarehouse : false
      ),
    enabled: batchId && batchId !== null,
  });

  return (
    <div className="">
      <PageTemplateNew
        header={
          isFetchingDetail ? (
            <CircularProgress size={20} />
          ) : dataDetail ? (
            `Kartu Stok ${dataDetail[0]?.product_name} (${
              dataDetail[0]?.number_batch
            }) ${isWarehouse ? "Central Warehouse" : ""}`
          ) : (
            "Detail Batch Kartu Stok " +
            (isWarehouse ? "Central Warehouse" : "")
          )
        }
        mainComponent={
          <CardStockDetailBatch
            isWarehouse={isWarehouse}
            dataDetail={dataDetail}
            isFetchingDetail={isFetchingDetail}
          />
        }
        pageRole={isWarehouse ? 30 : 24}
        breadcrumb={
          <BreadcrumbCardstock
            isWarehouse={isWarehouse ? isWarehouse : false}
            batchName={dataDetail ? dataDetail[0]?.number_batch : ""}
          />
        }
      />
    </div>
  );
};

export default HOC(CardStockDetailBatchPage);
